export const getTableQueryKey = (options: {
  tableKey: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  filterParams: any
  page?: number
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  products?: any
}) => [
  options.tableKey,
  JSON.stringify(options.filterParams),
  String(options.page ?? 1),
  String(options.products ?? ''),
]
